import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

function NewsCard({ item, lang, t, onClick }) {
  const title = item[`title_${lang}`] || item.title_cs;
  const body = item[`body_${lang}`] || item.body_cs;
  const date = new Date(item.published_at).toLocaleDateString(
    lang === 'cs' ? 'cs-CZ' : lang === 'sk' ? 'sk-SK' : 'ro-RO'
  );

  // Strip HTML for preview
  const preview = body.replace(/<[^>]+>/g, '').slice(0, 160) + '...';

  return (
    <div
      onClick={onClick}
      style={{
        background: '#fff',
        borderRadius: 12,
        padding: '24px',
        boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
        border: '1px solid #f3f4f6',
        cursor: 'pointer',
        transition: 'all 0.2s',
      }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(192,57,43,0.12)'; e.currentTarget.style.borderColor = '#fca5a5'; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 6px rgba(0,0,0,0.06)'; e.currentTarget.style.borderColor = '#f3f4f6'; }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#111827', lineHeight: 1.4 }}>
          {title}
        </h2>
        <span style={{
          whiteSpace: 'nowrap',
          fontSize: 12,
          color: '#9ca3af',
          marginTop: 3,
        }}>{date}</span>
      </div>
      <p style={{ margin: '12px 0 16px', fontSize: 14, color: '#6b7280', lineHeight: 1.6 }}>
        {preview}
      </p>
      <span style={{
        fontSize: 13,
        fontWeight: 600,
        color: '#0e76bc',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
      }}>
        {t('readMore')} →
      </span>
    </div>
  );
}

function NewsDetail({ item, lang, t, onBack }) {
  const title = item[`title_${lang}`] || item.title_cs;
  const body = item[`body_${lang}`] || item.body_cs;
  const date = new Date(item.published_at).toLocaleDateString(
    lang === 'cs' ? 'cs-CZ' : lang === 'sk' ? 'sk-SK' : 'ro-RO'
  );

  return (
    <div>
      <button onClick={onBack} style={{
        background: 'none',
        border: 'none',
        color: '#0e76bc',
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        padding: 0,
        marginBottom: 20,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        fontFamily: 'inherit',
      }}>
        ← {t('back')}
      </button>
      <div style={{
        background: '#fff',
        borderRadius: 12,
        padding: '32px',
        boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
        border: '1px solid #f3f4f6',
      }}>
        <div style={{ marginBottom: 8 }}>
          <span style={{ fontSize: 12, color: '#9ca3af' }}>{t('publishedAt')}: {date}</span>
        </div>
        <h1 style={{ margin: '0 0 24px', fontSize: 26, fontWeight: 800, color: '#111827', lineHeight: 1.3 }}>
          {title}
        </h1>
        <div
          style={{ fontSize: 16, color: '#374151', lineHeight: 1.8 }}
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </div>
    </div>
  );
}

export default function NewsPage() {
  const { lang, t, apiFetch } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    apiFetch('/news')
      .then(setItems)
      .finally(() => setLoading(false));
  }, [apiFetch]);

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('loading')}</div>;

  if (selected) return <NewsDetail item={selected} lang={lang} t={t} onBack={() => setSelected(null)} />;

  return (
    <div>
      <h1 style={{ margin: '0 0 24px', fontSize: 26, fontWeight: 800, color: '#111827' }}>
        📰 {t('newsTitle')}
      </h1>
      {items.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('noNews')}</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 20 }}>
          {items.map(item => (
            <NewsCard key={item.id} item={item} lang={lang} t={t} onClick={() => setSelected(item)} />
          ))}
        </div>
      )}
    </div>
  );
}
